export const cacheKeys = {
  getStories: 'getStories',
  getStory: 'getStory',
  createStory: 'createStory',
  editStory: 'editStory',
  deleteStory: 'deleteStory',
  getStoryTags: 'getStoryTags',
};
